var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-container"},[_c('div',{class:_vm.isTheme ? 'tab-list-theme' : 'tab-list'},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.value,class:[
        _vm.isTheme ? 'tab-trigger-theme' : 'tab-trigger', 
        { active: _vm.internalValue === tab.value },
        { disabled: _vm.disabled }
      ],on:{"click":function($event){return _vm.updateValue(tab.value)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0),_c('div',{staticClass:"tab-content"},[_vm._t("default",null,{"active":_vm.internalValue})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }